import store from "@/store/VuexPlugin";
import { restoreFromLocalStorage } from "@/lib/restoreFromLocalStorage";
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "ui",
  store
})
export class UiStore extends VuexModule {
  /**
   * Stores a global loading state.
   */
  loading = true;

  /**
   * Stores the <see cref="TheLayoutBase"/> drawer state.
   */
  drawer: boolean | null = false;

  /**
   * Resource selected as the booking calendar filter on the booking view.
   */
  bookingSelectedResourceId: string | null = restoreFromLocalStorage("bookingSelectedResourceId", "ui", null);

  /**
   * Whether the resource side panel on the booking view is expanded.
   */
  bookingShowResourcePanel: boolean = restoreFromLocalStorage("bookingShowResourcePanel", "ui", true);

  /**
   * Sets the drawer to open or closed
   * @param val Sets the drawer to open or closed
   */
  @Action
  setDrawer(val: boolean | null) {
    this.context.commit("updateDrawer", val);
  }

  /**
   * Toggles the menu drawer
   * @param val drawer open or closed
   */
  @Mutation
  updateDrawer(val: boolean | null) {
    this.drawer = val;
  }

  /**
   * Sets a global loading state for the ui.
   * @param loading boolean if loading is true
   * @returns loading status
   */
  @MutationAction
  async setLoading(loading: boolean) {
    return {
      loading
    };
  }

  @Mutation
  updateBookingSelectedResourceId(resourceId: string | null) {
    this.bookingSelectedResourceId = resourceId;
  }

  @Action
  setBookingSelectedResourceId(resourceId: string | null) {
    this.context.commit("updateBookingSelectedResourceId", resourceId);
  }

  @Mutation
  updateBookingShowResourcePanel(show: boolean) {
    this.bookingShowResourcePanel = show;
  }

  @Action
  setBookingShowResourcePanel(show: boolean) {
    this.context.commit("updateBookingShowResourcePanel", show);
  }
}

export const UiModule = getModule(UiStore);
